import { render, staticRenderFns } from "./assetprofile.vue?vue&type=template&id=4e5839c3&scoped=true"
import script from "./assetprofile.js?vue&type=script&lang=js&external"
export * from "./assetprofile.js?vue&type=script&lang=js&external"
import style0 from "./assetprofile.vue?vue&type=style&index=0&id=4e5839c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5839c3",
  null
  
)

export default component.exports